import React from 'react';
import { Creatable } from 'react-select-plus';
import InputField from '../../../../components/input-field/InputField';
import ToggleRow from '../../../../components/toggle-row/ToggleRow';
import SmallJSONEditor from '../../../../components/small-json-editor/SmallJSONEditor';
import ValidationService from '../../../../services/ValidationService';
import RESTService from '../../../../services/RESTService';
import Dropdown from '../../../../components/dropdown/Dropdown';
import RoutingService from '../../../../services/RoutingService';
import ComponentHelper from '../../../../supers/ComponentHelper';
import TestRunnerModal from '../../../../components/test-runner-modal/TestRunnerModal';
import SampleRequestCard from '../../../../components/sample-request-card/SampleRequestCard';
import CommonService from '../../../../services/CommonService';
import _ from 'lodash';
const VS = new ValidationService();
const connect = new RESTService();
const RS = new RoutingService();
const CS = new CommonService();

class SoapConnector extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = this.defaultState();
		this.scanForParams();
		this.autoBind([
			'onBuildConnectionState',
			'onValueChange',
			'onTestConnection',
			'onChecked',
			'onAuthChange',
			'handleHeadersChange',
			'handleHttpHeadersChange',
			'handleArgumentsOnChange',
			'handleHttpOptionsChange',
			'handleIgnoreNameSpaceChange',
			'handleSoapOptionsExtraContentChange',
			'onToggleIgnoreBaseNameSpace',
			'onToggleIgnoreChildNameSpace',
			'onClearConnection',
			'isValidConnection',
			'onBuildConnection',
			'onCreateConnection',
			'buildTypeDefault',
			'scanForParams',
			'onSetEmpty',
			'onClearValue',
			'onDefaultChange',
			'getIsDisabled'
		]);
	}

	getIsDisabled(field) {
		return this.data.disabled[field];
	}

	defaultState = () => {
		if (this.props.connection) {
			return this.onBuildConnectionState(this.props.connection);
		}

		let namespaceList = [
			{ value: 'tns', label: 'tns', className: 'Select-create-option-placeholder' },
			{ value: 'typedNamespace', label: 'typedNamespace', className: 'Select-create-option-placeholder' },
			{ value: 'targetNamespace', label: 'targetNamespace', className: 'Select-create-option-placeholder' }
		];

		return {
			authOpen: false,
			headersOpen: false,
			soapOptionsOpen: false,
			httpHeadersOpen: false,
			httpOptionsOpen: false,
			httpOptionsSSLCert: true,
			argsOpen: false,
			soapIgnoreBaseNameSpaces: false,
			soapIgnoreChildNamespaces: false,
			testing: false,
			runningTest: false,
			agents: [],
			agentContent: '',
			agentsOpen: false,
			name: '',
			url: '',
			authContent: '',
			authType: 'basic',
			argsContent: '',
			username: '',
			password: '',
			sslUsername: '',
			sslPassword: '',
			bearerToken: '',
			sslKey: '',
			sslCertificate: '',
			wsUsername: '',
			wsPassword: '',
			customPrefix: '',
			customToken: '',
			headersContent: '',
			soapOptionsContent: '',
			soapAttributesKey: '',
			soapvalueKey: '',
			soapxmlKey: '',
			soapIgnoreNamespaceContainer: '',
			soapIgnoreSelectValue: '',
			soapIgnoreNameSpaceList: namespaceList,
			soapOptionsExtraContent: '',
			httpHeadersContent: '',
			httpOptionsContent: '',
			testingAction: '',
			timeout: 0,
			requestParams: {},
			disabled: {},
			namespaceList
		};
	};

	componentDidMount() {
		connect.getAgents().then(res => {
			this.setData('agents', res.data);
		});
	}

	onBuildConnectionState(conn) {
		let config = conn.configuration;
		let auth = config.auth;
		let soap = config.soapOptions;
		let authType = 'basic';
		let username = '';
		let password = '';
		let bearerToken = '';
		let sslUsername = '';
		let sslPassword = '';
		let sslKey = '';
		let sslCertificate = '';
		let wsUsername = '';
		let wsPassword = '';
		let customPrefix = '';
		let customToken = '';

		let namespaceList = [
			{ value: 'tns', label: 'tns', className: 'Select-create-option-placeholder' },
			{ value: 'typedNamespace', label: 'typedNamespace', className: 'Select-create-option-placeholder' },
			{ value: 'targetNamespace', label: 'targetNamespace', className: 'Select-create-option-placeholder' }
		];

		if (soap !== undefined) {
			if (soap.ignoredNamespaces !== undefined) {
				//If there is an ignored namespace object check to see if there are
				//any non-default values
				if (soap.ignoredNamespaces.nameespaces.length > 0) {
					let nsArray = soap.ignoredNamespaces.nameespaces;
					for (let i = 0; i < nsArray.length; i++) {
						namespaceList.push({
							value: nsArray[i],
							label: nsArray[i],
							className: 'Select-create-option-placeholder'
						});
					}
				}
			}
		}

		if (auth) {
			authType = auth.type;
			if (auth.type === 'basic') {
				username = auth.username;
				password = auth.password;
			} else if (auth.type === 'bearer') {
				bearerToken = auth.token;
			} else if (auth.type === 'ssl') {
				sslUsername = auth.username;
				sslPassword = auth.password;
				sslKey = auth.key;
				sslCertificate = auth.certificate;
			} else if (auth.type === 'ws') {
				wsUsername = username;
				wsPassword = password;
			} else if (auth.type === 'custom') {
				customPrefix = auth.prefix;
				customToken = auth.token;
			}
		}

		let state = {
			testing: conn.testing,
			testingAction: '',
			actionType: '',
			agents: this.data.agents ? this.data.agents : [],
			agentContent: conn.agent ? conn.agent : '',
			agentsOpen: conn.agent && conn.agent.length > 0 ? true : false,
			authOpen: auth ? true : false,
			headersOpen: config.headers ? true : false,
			soapOptionsOpen: config.soapOptions ? true : false,
			httpHeadersOpen: config.reqHeaders ? true : false,
			httpOptionsOpen: config.httpOptions ? true : false,
			argsOpen: config.args ? true : false,
			name: conn.name,
			type: conn.type,
			url: config.url ? config.url : '',
			timeout: config.timeout ? config.timeout : 0,
			headersContent: config.headers ? JSON.stringify(config.headers, undefined, 2) : '',
			soapAttributesKey: soap ? soap.attributesKey : '',
			soapvalueKey: soap ? soap.valueKey : '',
			soapxmlKey: soap ? soap.xmlKey : '',
			soapIgnoreNameSpaceList: namespaceList,
			soapIgnoreBaseNameSpaces: soap ? soap.ignoreBaseNameSpaces : false,
			soapIgnoreChildNamespaces: soap ? soap.ignoreChildNamespaces : false,
			httpOptionsContent: config.httpOptions ? JSON.stringify(config.httpOptions, undefined, 2) : '',
			httpHeadersContent: config.reqHeaders ? JSON.stringify(config.reqHeaders, undefined, 2) : '',
			httpOptionsSSLCert: config.httpOptions ? config.httpOptions.strictSSL : '',
			argsContent: config.args ? JSON.stringify(config.args, undefined, 2) : '',
			runningTest: false,
			requestParams: {},
			disabled: {},
			authType,
			username,
			password,
			bearerToken,
			sslUsername,
			sslPassword,
			sslKey,
			sslCertificate,
			wsUsername,
			wsPassword,
			customPrefix,
			customToken,
			namespaceList
		};

		let disabled = {};
		if (state.testing || this.props.endpoint) {
			if (state.authOpen) {
				disabled.auth = true;
			}
			if (state.headersContent.length > 0) {
				disabled.headersContent = true;
			}
			if (state.soapOptionsOpen.length > 0) {
				disabled.soapOptions = true;
			}
			if (state.httpHeadersContent.length > 0) {
				disabled.httpHeadersContent = true;
			}
			if (state.httpOptionsContent.length > 0) {
				disabled.httpOptionsContent = true;
			}
			if (state.argsContent.length > 0) {
				disabled.argsContent = true;
			}
			if (state.agentsOpen) {
				disabled.agent = true;
			}
		}
		state.disabled = disabled;

		return state;
	}

	onValueChange = evt => {
		const { name, value } = evt.target;
		if (name === 'name' && !VS.validateName(value)) {
			return;
		}
		this.observe(() => {
			this.data[name] = value;
			this.scanForParams();
		});
	};

	onBuildConnection = () => {
		let data = this.data;
		let connection = {
			name: data.name,
			type: 'soap-connector',
			configuration: {
				url: data.url
			}
		};
		if (data.timeout >= 0) {
			connection.timeout = data.timeout;
		}
		if (data.authOpen) {
			connection.configuration.auth = {
				type: data.authType
			};
			if (data.authType === 'basic') {
				connection.configuration.auth.username = data.username;
				connection.configuration.auth.password = data.password;
			} else if (data.authType === 'bearer') {
				connection.configuration.auth.token = data.bearerToken;
			} else if (data.authType === 'ssl') {
				connection.configuration.auth.username = data.sslUsername;
				connection.configuration.auth.password = data.sslPassword;
				connection.configuration.auth.key = data.sslKey;
				connection.configuration.auth.certificate = data.sslCertificate;
			} else if (data.authType === 'ws') {
				connection.configuration.auth.username = data.wsUsername;
				connection.configuration.auth.password = data.wsPassword;
			} else if (data.authType === 'custom') {
				connection.configuration.auth.prefix = data.customPrefix;
				connection.configuration.auth.token = data.customToken;
			}
		}
		if (data.headersOpen) {
			if (data.headersContent.length > 0) {
				let val = CS.safelyParseJSON(data.headersContent);
				if (!val) {
					this.invalidForm = true;
					return;
				}
				connection.configuration.headers = val;
			}
		}
		if (data.soapOptionsOpen) {
			const soapOptions = (connection.configuration.soapOptions =
				data.soapOptionsExtraContent !== '' ? CS.safelyParseJSON(data.soapOptionsExtraContent) : {});
			if (soapOptions === undefined) {
				this.invalidForm = true;
				return;
			}
			let ignoredNamespaces = (soapOptions.ignoreNamespaces = {});
			soapOptions.attributesKey = data.soapAttributesKey;
			soapOptions.valueKey = data.soapvalueKey;
			soapOptions.xmlKey = data.soapxmlKey;

			if (data.soapIgnoreNameSpaceList.length > 0) {
				let namespaces = [];

				for (let i = 0; i < data.soapIgnoreNameSpaceList.length; i++) {
					//Check the list of default names space to ensure that they are not the default
					if (i < data.namespaceList.length) {
						if (!data.namespaceList[i].value.includes(data.soapIgnoreNameSpaceList[i].value)) {
							namespaces.push(data.soapIgnoreNameSpaceList[i].value);
							ignoredNamespaces.override = true;
						}
					} else {
						namespaces.push(data.soapIgnoreNameSpaceList[i].value);
						ignoredNamespaces.override = true;
					}
				}

				ignoredNamespaces.nameespaces = namespaces;
			}

			if (data.soapIgnoreBaseNameSpaces) {
				soapOptions.ignoreBaseNameSpaces = data.soapIgnoreBaseNameSpaces;
			}

			if (data.soapIgnoreChildNamespaces) {
				soapOptions.ignoreChildNamespaces = data.soapIgnoreChildNamespaces;
			}
		}

		if (data.httpHeadersOpen) {
			connection.configuration.reqHeaders = {};
			if (data.httpHeadersContent.length > 0) {
				let val = CS.safelyParseJSON(data.httpHeadersContent);
				if (!val) {
					this.invalidForm = true;
					return;
				}
				connection.configuration.reqHeaders = val;
			}
		}
		if (data.httpOptionsOpen) {
			if (data.httpOptionsContent.length > 0) {
				let val = CS.safelyParseJSON(data.httpOptionsContent);
				if (!val) {
					this.invalidForm = true;
					return;
				}
				connection.configuration.httpOptions = val;
			}
			//not sure why this was here
			//connection.configuration.httpOptions.strictSSL = data.httpOptionsSSLCert;
		}

		if (data.argsOpen) {
			if (data.argsContent.length > 0) {
				let val = CS.safelyParseJSON(data.argsContent);
				if (!val) {
					this.invalidForm = true;
					return;
				}
				connection.configuration.args = val;
			}
		}

		if (data.agentsOpen) {
			connection.agent = data.agentContent;
		} else {
			connection.agent = '';
		}

		return connection;
	};

	onTestConnection = () => {
		return connect.testConnection(this.buildTestConnection());
	};

	buildTestConnection = () => {
		let connection = this.onBuildConnection(true);
		let is = this.onBuildConnectionState(this.props.connection);
		let config = {};
		if (!is.authOpen && this.data.authOpen) {
			config.auth = connection.configuration.auth;
		}
		if (!is.soapOptionsOpen && this.data.soapOptionsOpen) {
			config.soapOptions = connection.configuration.soapOptions;
		}
		if (!is.httpHeadersOpen && this.data.httpHeadersOpen) {
			config.headers = connection.configuration.headers;
		}
		if (!is.httpOptionsOpen && this.data.httpOptionsOpen) {
			config.httpOptions = connection.configuration.httpOptions;
		}
		if (!is.argsOpen && this.data.argsOpen) {
			config.args = connection.configuration.args;
		}
		let testData = CS.buildRequestTestData(this.data.requestParams);
		testData._async = this.data.async ? true : false;
		return {
			application: 'global',
			sandbox: RS.getCurrentEnvironment(),
			endpoint: {
				action: this.data.testingAction,
				configuration: config,
				connection: connection.name,
				templates: CS.buildRequestTemplate(this.data.requestParams),
				type: 'Operation'
			},
			testValues: testData
		};
	};

	scanForParams() {
		let keys = ['url', 'headersContent', 'httpOptionsContent', 'httpHeadersContent', 'argsContent', 'soapOptionsExtraContent'];
		this.data.requestParams = CS.buildRequestParams(keys, this.data);
		if (this.props.endpointWatcher) {
			this.props.endpointWatcher({
				cmp: this,
				data: this.data,
				builder: this.buildTestConnection
			});
		}
	}

	onSetEmpty(evt) {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				this.data.requestParams[name].value = '';
			});
		}
	}

	onClearValue(evt) {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				this.data.requestParams[name].value = undefined;
			});
		}
	}

	onDefaultChange(evt) {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				let field = this.data.requestParams[name];
				field.value = evt.target.value;
				this.data.requestParams[name] = field;
			});
		}
	}

	buildTypeDefault(details, param) {
		return (
			<div className="inline-btn-input hbox vcenter default">
				<input
					className="text-input"
					type="text"
					placeholder={details.value === '' ? 'Empty String' : 'None'}
					value={details.value}
					data-name={param}
					onChange={this.onDefaultChange}
				/>
				<button className="btn inline-btn no-radius vbox hcenter vcenter" data-name={param} onClick={this.onSetEmpty}>
					Set as empty
				</button>
				<button className="btn inline-btn  vbox hcenter vcenter" data-name={param} onClick={this.onClearValue}>
					Clear
				</button>
			</div>
		);
	}

	onChecked = evt => {
		const { dataset, checked } = evt.target;
		this.setData(dataset.name, checked);
	};

	onAuthChange = evt => {
		this.setData('authType', evt.value);
	};

	handleHeadersChange = newValue => {
		this.observe(() => {
			this.data.headersContent = newValue;
			this.scanForParams();
		});
	};

	handleHttpHeadersChange = newValue => {
		this.observe(() => {
			this.data.httpHeadersContent = newValue;
			this.scanForParams();
		});
	};

	handleArgumentsOnChange = newValue => {
		this.observe(() => {
			this.data.argsContent = newValue;
			this.scanForParams();
		});
	};

	handleHttpOptionsChange = newValue => {
		this.observe(() => {
			this.data.httpOptionsContent = newValue;
			this.scanForParams();
		});
	};

	handleIgnoreNameSpaceChange = newValue => {
		this.setData('soapIgnoreNameSpaceList', newValue);
	};

	handleSoapOptionsExtraContentChange = newValue => {
		this.observe(() => {
			this.data.soapOptionsExtraContent = newValue;
			this.scanForParams();
		});
	};

	onToggleIgnoreBaseNameSpace = () => {
		this.setData('soapIgnoreBaseNameSpaces', !this.data.soapIgnoreBaseNameSpaces);
	};

	onToggleIgnoreChildNameSpace = () => {
		this.setData('soapIgnoreChildNamespaces', !this.data.soapIgnoreChildNamespaces);
	};

	onClearConnection = () => {
		this.observe(() => {
			this.data = this.defaultState();
		});
	};

	isValidConnection = () => {
		let data = this.data;

		if (data.name.length === 0) {
			return true;
		}

		if (data.authOpen) {
			if (data.authType === 'basic') {
				if (data.username.length === 0 && data.password === 0) {
					return true;
				}
			} else if (data.authType === 'bearer') {
				if (data.bearerToken.length === 0) {
					return true;
				}
			} else if (data.authType === 'ssl') {
				if (data.sslUsername.length === 0) {
					return true;
				} else if (data.sslPassword.length === 0) {
					return true;
				} else if (data.sslKey.length === 0) {
					return true;
				} else if (data.sslCertificate.length === 0) {
					return true;
				}
			} else if (data.authType === 'ws') {
				if (data.wsUsername.length === 0) {
					return true;
				} else if (data.wsPassword.length === 0) {
					return true;
				}
			} else if (data.authType === 'custom') {
				if (data.customPrefix.length === 0) {
					return true;
				} else if (data.customToken.length === 0) {
					return true;
				}
			}
		}

		if (data.headersOpen) {
			if (data.headersContent.length === 0) {
				return true;
			}
		}

		if (data.httpHeadersOpen) {
			if (data.httpHeadersContent.length === 0) {
				return true;
			}
		}

		if (data.argsOpen) {
			if (data.argsContent.length === 0) {
				return true;
			}
		}

		return false;
	};

	onCreateConnection = () => {
		let connection = this.onBuildConnection();
		if (this.invalidForm) {
			RS.smartError('Invalid JSON');
			return;
		}
		if (this.props.connection) {
			delete connection.type;
			connect
				.updateConnection(connection)
				.then(res => {
					this.observe(() => {
						this.data = this.onBuildConnectionState(res.data);
					});
					RS.showSuccess();
				})
				.catch(err => {
					RS.smartError(err);
				});
		} else {
			connect
				.createConnection(connection)
				.then(() => {
					RS.showSuccess();
					RS.goToRoute('/connections');
				})
				.catch(err => {
					RS.smartError(err);
				});
		}
	};

	toggleTestRunner = () => {
		this.setData('runningTest', !this.data.runningTest);
	};

	runTest = () => {
		if (this.data.testingAction.length === 0) {
			return RS.showInfo('You must provide an action type');
		}
		this.onBuildConnection();
		if (this.invalidForm) {
			RS.smartError('Invalid JSON');
			return;
		}
		this.observe(() => {
			this.data.runningTest = true;
		});
	};

	toggleAsync = () => {
		this.setData('async', !this.data.async);
	};

	onAgentChange = evt => {
		if (evt.value) {
			this.setData('agentContent', evt.value);
		}
	};

	getAgentOptions = () => {
		let agents = [];
		_.forEach(this.data.agents, ag => {
			agents.push({
				label: ag.name,
				value: ag.name
			});
		});
		return agents;
	};

	render() {
		let {
			name,
			url,
			testing,
			timeout,
			authOpen,
			headersOpen,
			soapOptionsOpen,
			httpHeadersOpen,
			httpOptionsOpen,
			httpOptionsSSLCert,
			argsOpen,
			authType,
			testingAction,
			username,
			password,
			sslUsername,
			sslPassword,
			bearerToken,
			sslKey,
			sslCertificate,
			wsUsername,
			wsPassword,
			customPrefix,
			customToken,
			headersContent,
			soapAttributesKey,
			soapvalueKey,
			soapxmlKey,
			soapIgnoreBaseNameSpaces,
			soapIgnoreChildNamespaces,
			soapOptionsExtraContent,
			soapIgnoreNameSpaceList,
			httpHeadersContent,
			httpOptionsContent,
			argsContent,
			runningTest,
			agentsOpen,
			agentContent,
			async
		} = this.data;
		return (
			<div className="soap-connector-cmp">
				<div className="step-card shadow animated fadeIn">
					<div className="hbox">
						<InputField
							label="Name"
							subText="Use only lowercase characters, numbers or hyphens."
							type="text"
							name="name"
							value={name}
							handleChange={this.onValueChange}
							disabled={this.props.connection ? true : false}
							required
							autoFocus
						/>
					</div>
					<div className="hbox field-ctn">
						<InputField
							className="m-r-20"
							label="URL"
							subText="Base URL or host for the Exchange instance."
							type="text"
							name="url"
							value={url}
							handleChange={this.onValueChange}
							disabled={testing}
						/>
						<div className="timeout-ctn">
							<InputField
								name="timeout"
								label="Timeout"
								value={timeout}
								handleChange={this.onValueChange}
								subText="Optional time to wait for the response headers in milliseconds. This must be lower than the global Platform timeout (10s)."
								type="number"
							/>
						</div>
					</div>

					<ToggleRow
						name="User Authentication"
						details="Enable if the SOAP service requires authentication."
						toggleOn={authOpen}
						keyName={'authOpen'}
						onToggle={this.onChecked}
						content={
							<div>
								<div className="auth-content hbox vcenter">
									<Dropdown
										className="auth-dd m-r-20"
										label="Type"
										value={authType}
										handleChange={this.onAuthChange}
										name="authType"
										disabled={this.getIsDisabled('auth')}
										options={[
											{
												label: 'Basic',
												value: 'basic'
											},
											{
												label: 'Bearer',
												value: 'bearer'
											},
											{
												label: 'SSL',
												value: 'ssl'
											},
											{
												label: 'WS',
												value: 'ws'
											},
											{
												label: 'Custom',
												value: 'custom'
											}
										]}
									/>
									{authType === 'basic' && [
										<InputField
											className="m-r-20"
											key="http-connector-username-key"
											label="Username"
											type="text"
											name="username"
											value={username}
											handleChange={this.onValueChange}
											disabled={this.getIsDisabled('auth')}
										/>,
										<InputField
											className="m-r-20"
											key="http-connector-password-key"
											label="Password"
											type="password"
											name="password"
											value={password}
											handleChange={this.onValueChange}
											disabled={this.getIsDisabled('auth')}
										/>
									]}
									{authType === 'bearer' && (
										<InputField
											className="m-r-20"
											label="Token"
											type="text"
											name="token"
											value={bearerToken}
											handleChange={this.onValueChange}
											disabled={this.getIsDisabled('auth')}
										/>
									)}
									{authType === 'ssl' && [
										<InputField
											className="m-r-20"
											key="soap-connector-username-key"
											label="Username"
											type="text"
											name="sslUsername"
											value={sslUsername}
											handleChange={this.onValueChange}
											disabled={this.getIsDisabled('auth')}
										/>,
										<InputField
											className="m-r-20"
											key="soap-connector-password-key"
											label="Password"
											type="password"
											name="sslPassword"
											value={sslPassword}
											handleChange={this.onValueChange}
											disabled={this.getIsDisabled('auth')}
										/>
									]}
									{authType === 'ws' && [
										<InputField
											className="m-r-20"
											key="soap-connector-ws-username-key"
											label="Username"
											type="text"
											name="wsUsername"
											value={wsUsername}
											handleChange={this.onValueChange}
											disabled={this.getIsDisabled('auth')}
										/>,
										<InputField
											className="m-r-20"
											key="soap-connector-ws-password-key"
											label="Password"
											type="password"
											name="wsPassword"
											value={wsPassword}
											handleChange={this.onValueChange}
											disabled={this.getIsDisabled('auth')}
										/>
									]}
									{authType === 'custom' && [
										<InputField
											className="m-r-20"
											key="soap-connector-custom-prefix-key"
											label="Prefix"
											type="text"
											name="customPrefix"
											value={customPrefix}
											handleChange={this.onValueChange}
											disabled={this.getIsDisabled('auth')}
										/>,
										<InputField
											className="m-r-20"
											key="soap-connector-custom-token-key"
											label="Token"
											type="text"
											name="customToken"
											value={customToken}
											handleChange={this.onValueChange}
											disabled={this.getIsDisabled('auth')}
										/>
									]}
								</div>
								{authType === 'ssl' && [
									<InputField
										key="soap-connector-ssl-key"
										label="Key"
										type="text"
										name="sslKey"
										value={sslKey}
										handleChange={this.onValueChange}
										disabled={this.getIsDisabled('auth')}
									/>,
									<InputField
										key="soap-connector-ssl-username-key"
										label="Certificate"
										type="text"
										name="sslCertificate"
										value={sslCertificate}
										handleChange={this.onValueChange}
										disabled={this.getIsDisabled('auth')}
									/>
								]}
							</div>
						}
					/>
					<ToggleRow
						name="Headers"
						details={
							this.props.endpoint
								? 'Define any specific header required by the SOAP service.'
								: "Note that if you define headers at connection-level you won't be able to define any header at endpoint-level."
						}
						toggleOn={headersOpen}
						keyName={'headersOpen'}
						onToggle={this.onChecked}
						icon={this.props.endpoint ? '' : <i className="mdi mdi-alert" />}
						content={
							<div className="header-content vbox vcenter">
								<SmallJSONEditor
									name="headers"
									value={headersContent}
									onChange={this.handleHeadersChange}
									readOnly={this.getIsDisabled('headersContent')}
								/>
								<div className="json-message">The SOAP headers must be defined as a valid JSON array.</div>
							</div>
						}
					/>
					<ToggleRow
						name="SOAP Options"
						details={
							this.props.endpoint
								? 'Define any specific SOAP options required by your service.'
								: "Note that if you define SOAP options at connection-level you won't be able to define any more options at endpoint-level."
						}
						toggleOn={soapOptionsOpen}
						keyName={'soapOptionsOpen'}
						onToggle={this.onChecked}
						icon={this.props.endpoint ? '' : <i className="mdi mdi-alert" />}
						content={
							<div className="soap-options-content">
								<div className="hbox">
									<InputField
										className="m-r-20"
										key="soap-options-content-value-key"
										subText="By default, the connector uses $value as key for any parsed XML value which may interfere with your other code as it could be some reserved word, or the $ in general cannot be used for a key to start with. Here you can define your own value key."
										label="Value Key"
										type="text"
										name="soapvalueKey"
										value={soapvalueKey}
										handleChange={this.onValueChange}
										disabled={this.getIsDisabled('soapOptions')}
									/>
									<InputField
										className="m-r-20"
										key="soap-options-content-xml-key"
										subText="By default, the connector uses $xml as XML key to pass an XML Object without adding namespace or parsing the string. Here you can define your own XML key."
										label="XML Key"
										type="text"
										name="soapxmlKey"
										value={soapxmlKey}
										handleChange={this.onValueChange}
										disabled={this.getIsDisabled('soapOptions')}
									/>
								</div>
								<InputField
									className="m-r-20"
									key="soap-options-content-attributes-key"
									subText="If attributes is a reserved key for your system you can define an alternative key."
									label="Attributes Key"
									type="text"
									name="soapAttributesKey"
									value={soapAttributesKey}
									handleChange={this.onValueChange}
									disabled={this.getIsDisabled('soapOptions')}
								/>

								<div className="vbox ignore-namespace-content">
									<div className="soap-sub-title">Ignored Namespaces</div>
									<div className="sub-text">
										If an element in a "schema" definition depends on an Element which is present in the same namespace, normally the "tns:" namespace
										prefix is used to identify this Element. This is not much of a problem as long as you have just one "schema" defined (inline or in
										a separate file). If there are more "schema" files, the "tns:" in the generated "soap" file resolved mostly to the parent "wsdl"
										file, which was obviously wrong.
									</div>
									<div className="sub-text">
										The connector handles namespace prefixes which shouldn't be resolved (because it's not necessary) as so called ignored namespaces
										which default to this three 'tns', 'targetNamespace' and 'typedNamespace'. If this is not sufficient for your purpose you can
										easily add more namespace prefixes.
									</div>
								</div>

								<Creatable
									name="ignore-namespace-values"
									value={soapIgnoreNameSpaceList}
									onChange={this.handleIgnoreNameSpaceChange}
									multi={true}
									disabled={this.getIsDisabled('soapOptions')}
									options={[
										{ value: 'tns', label: 'tns' },
										{ value: 'typedNamespace', label: 'typedNamespace' },
										{ value: 'targetNamespace', label: 'targetNamespace' }
									]}
								/>
								<div className="multi-select-namespace-content sub-text">Click ENTER or TAB to add namespace value</div>

								<div className="hbox checkbox-col">
									<input
										type="checkbox"
										checked={soapIgnoreBaseNameSpaces}
										onChange={this.onToggleIgnoreBaseNameSpace}
										disabled={this.getIsDisabled('soapOptions')}
									/>
									<div className="label">Ignore Base Namespaces</div>
								</div>
								<div className="sub-text">
									If an Element in a schema definition depends has a base namespace defined but the request does not need that value, for example you
									have a sentJob with base namespace v20 but the request need only: set in the tree structure, you need to enable this field. This is
									set because in a lot of workaround the WSDL structure is not correctly set or the web-service bring errors.
								</div>
								<div className="hbox checkbox-col">
									<input
										type="checkbox"
										checked={soapIgnoreChildNamespaces}
										onChange={this.onToggleIgnoreChildNameSpace}
										disabled={this.getIsDisabled('soapOptions')}
									/>
									<div className="label">Ignore Child Namespaces</div>
								</div>
								<div className="sub-text">
									Sometimes a SOAP service definition duplicates the namespaces in the entities defined in the XSD and builds the request wrong. You
									may think the option "Ignore base namespaces" would work, but that option only ignores the root namespace prefix and not the
									namespace prefix created from the XSD entities for the request.
								</div>
								<div className="soap-option-extra-content">
									<div className="soap-sub-title">Extra options</div>
									<SmallJSONEditor
										name="headers"
										value={soapOptionsExtraContent}
										onChange={this.handleSoapOptionsExtraContentChange}
										disabled={this.getIsDisabled('soapOptions')}
									/>
									<div className="json-message">
										Here you can add additional SOAP options in JSON format. They will be merged with the ones defined above.
									</div>
								</div>
							</div>
						}
					/>
					<ToggleRow
						name="HTTP Headers"
						details={
							this.props.endpoint
								? 'Define any specific HTTP headers required by your service.'
								: "Note that if you define HTTP request headers at connection-level you won't be able to define more headers at endpoint-level."
						}
						toggleOn={httpHeadersOpen}
						keyName={'httpHeadersOpen'}
						onToggle={this.onChecked}
						icon={this.props.endpoint ? '' : <i className="mdi mdi-alert" />}
						content={
							<div className="http-headers-content vbox vcenter">
								<SmallJSONEditor
									name="headers"
									value={httpHeadersContent}
									onChange={this.handleHttpHeadersChange}
									readOnly={this.getIsDisabled('httpHeadersContent')}
								/>
								<div className="json-message">The HTTP request headers must be defined as a valid JSON object.</div>
							</div>
						}
					/>
					<ToggleRow
						name="HTTP Options"
						details={
							this.props.endpoint
								? 'Define any specific HTTP options required by your service.'
								: "Note that if you define HTTP options at connection-level you won't be able to define more options at endpoint-level."
						}
						toggleOn={httpOptionsOpen}
						keyName={'httpOptionsOpen'}
						onToggle={this.onChecked}
						icon={this.props.endpoint ? '' : <i className="mdi mdi-alert" />}
						content={
							<div>
								<div className="http-options-content vbox vcenter">
									<SmallJSONEditor
										name="headers"
										value={httpOptionsContent}
										onChange={this.handleHttpOptionsChange}
										readOnly={this.getIsDisabled('httpOptionsContent')}
									/>
									<div className="json-message">The HTTP options must be defined as a valid JSON object.</div>
								</div>

								<ToggleRow
									className="ssl-toggle"
									name="SSL Certificate Validation"
									details="The SSL validation can be disabled altogether in order to request servers using a certificate signed by an unknown Certificate Authority or a self-signed certificate. This is insecure and is recommended for testing purposes only."
									toggleOn={httpOptionsSSLCert}
									keyName={'httpOptionsSSLCert'}
									onToggle={this.onChecked}
									offContent={
										<div className="json-message">
											<i className="mdi mdi-alert" /> Insecure
										</div>
									}
								/>
							</div>
						}
					/>
					<ToggleRow
						name="Arguments"
						details={
							this.props.endpoint
								? 'Define any specific arguments required by your service.'
								: "Note that if you define arguments at connection-level you won't be able to define more arguments at endpoint-level."
						}
						toggleOn={argsOpen}
						keyName={'argsOpen'}
						onToggle={this.onChecked}
						icon={this.props.endpoint ? '' : <i className="mdi mdi-alert" />}
						content={
							<div className="arguments-content vbox vcenter">
								<SmallJSONEditor
									name="arguments"
									value={argsContent}
									onChange={this.handleArgumentsOnChange}
									readOnly={this.getIsDisabled('argsContent')}
								/>
								<div className="json-message">Arguments must be defined as a valid JSON object.</div>
							</div>
						}
					/>
					{!this.props.endpoint && (
						<ToggleRow
							name="Use an On-premise agent"
							details={
								'An agent is a process that runs in a virtual machine installed in a secure network. Once configured, it establishes a Web Socket connection with the Core Services platform, enabling the use of connectors that would otherwise be unreachable from the cloud.'
							}
							toggleOn={agentsOpen}
							keyName={'agentsOpen'}
							onToggle={this.onChecked}
							disabled={this.getIsDisabled('agent')}
							content={
								<div className="body-content vbox vcenter">
									<Dropdown
										className="w-100"
										label="Agent"
										value={agentContent}
										handleChange={this.onAgentChange}
										name="agentContent"
										disabled={this.getIsDisabled('agent')}
										options={this.getAgentOptions()}
									/>
								</div>
							}
						/>
					)}
					{testing &&
						!this.props.endpoint && (
							<div className="test-ctn vbox">
								<SampleRequestCard
									requestParams={this.data.requestParams}
									buildRequestFields={this.buildTypeDefault}
									validTest={true}
									onTest={this.runTest}
									async={async}
									toggleAsync={this.toggleAsync}
									content={
										<div className="hbox">
											<InputField
												label="Action"
												subText="SOAP action to be executed."
												type="text"
												name="testingAction"
												value={testingAction}
												handleChange={this.onValueChange}
												required
												autoFocus
											/>
										</div>
									}
								/>
								<TestRunnerModal isOpen={runningTest} onClose={this.toggleTestRunner} runTest={this.onTestConnection} async={async} />
							</div>
						)}
					{!this.props.endpoint && (
						<div className="btn-ctn">
							<button className="btn m-r-20" onClick={this.onClearConnection}>
								{this.props.connection ? 'Undo Changes' : 'Clear'}
							</button>
							<button className="btn primary" onClick={this.onCreateConnection} disabled={this.isValidConnection()}>
								{this.props.connection ? 'Save Connection' : 'Create Connection'}
							</button>
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default SoapConnector;



// WEBPACK FOOTER //
// ./src/views/connections-panel/connection-creator/soap-connector/SoapConnector.js